/* eslint-disable */
import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Grid, Typography } from '@material-ui/core';
import NoUser from '../../assets/NoUserIcon';
import ZeroState from '../common/ZeroState';

const columns = [
  { id: 'employeeName', label: 'Employee Name', minSize: 70, maxSize: 70, size: 70 },
  { id: 'departmentRoleTitle', label: 'Role', minSize: 70, maxSize: 70, size: 70 },
  {
    id: 'lastSeen',
    label: 'Inactivity',
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
  {
    id: 'employeeDevices',
    label: 'App Version',
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
  {
    id: 'learningDays',
    label: 'Active Days',
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
  {
    id: 'luCompleted',
    label: 'Learning Units',
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
  {
    id: 'rank',
    label: 'Rank',
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
  {
    id: 'totalStars',
    label: 'Stars',
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
  {
    id: 'notificationStatus',
    label: 'Notification',
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
  {
    id: 'action',
    label: 'Action',
    minSize: 70,
    maxSize: 70,
    size: 70,
  },
];

function createZeroActivityData(
  employeeName,
  departmentRoleTitle,
  lastSeen,
  employeeDevices,
  primaryContactEmail,
  hash,
) {
  return {
    employeeName: { name: employeeName, email: primaryContactEmail },
    departmentRoleTitle,
    lastSeen,
    employeeDevices: {
      version: employeeDevices?.length > 0 ? employeeDevices[0]?.appVersion : null,
      appType: employeeDevices?.length > 0 ? employeeDevices[0]?.appType : null,
      color: employeeDevices?.length > 0 ? employeeDevices[0]?.color : null,
    },
    action: 'disable',
    hash,
  };
}

function createRewardData(employees) {
  return employees?.map((employee) => ({
    employeeName: { name: employee.employeeName, email: employee.primaryContactEmail },
    departmentRoleTitle: employee.departmentRoleTitle,
    breakpoint: employee.breakpoint,
  }));
}

function createLearningActivityData(employeeName, departmentRoleTitle, learningDays, luCompleted, primaryContactEmail) {
  return {
    employeeName: { name: employeeName, email: primaryContactEmail },
    departmentRoleTitle,
    learningDays,
    luCompleted,
  };
}
function createAppConfigData(employeeName, departmentRoleTitle, employeeDevices, primaryContactEmail) {
  return {
    employeeName: { name: employeeName, email: primaryContactEmail },
    departmentRoleTitle,
    employeeDevices: {
      version: employeeDevices?.length > 0 ? employeeDevices[0]?.appVersion : null,
      appType: employeeDevices?.length > 0 ? employeeDevices[0]?.appType : null,
      color: employeeDevices?.length > 0 ? employeeDevices[0]?.color : null,
    },
    notificationStatus: {
      text: employeeDevices?.length > 0 ? employeeDevices[0]?.notificationStatus.text : 'NA',
      color: employeeDevices?.length > 0 ? employeeDevices[0]?.notificationStatus.color : 'black',
    },
  };
}
function createLeaderBoardData(employeeName, departmentRoleTitle, rank, totalStars, primaryContactEmail) {
  return { employeeName: { name: employeeName, email: primaryContactEmail }, departmentRoleTitle, rank, totalStars };
}

const MakeRows = (data, tabId) => {
  if (tabId === 0) {
    return data?.zeroActivity?.map((d) =>
      createZeroActivityData(
        d.employeeName,
        d.departmentRoleTitle,
        d.lastSeen,
        d.employeeDevices,
        d.primaryContactEmail,
        d.hash,
      ),
    );
  }
  if (tabId === 1) {
    return data?.learningActivity?.map((d) =>
      createLearningActivityData(
        d.employeeName,
        d.departmentRoleTitle,
        d.learningDays,
        d.luCompleted,
        d.primaryContactEmail,
      ),
    );
  }
  if (tabId === 2) {
    return data?.appConfig?.list?.map((d) =>
      createAppConfigData(d.employeeName, d.departmentRoleTitle, d.employeeDevices, d.primaryContactEmail),
    );
  }
  if (tabId === 3) {
    const guideRows = createRewardData(data?.rewards?.guideBadgeUnlockedEmployees);
    const storyRows = createRewardData(data?.rewards?.storyBadgeUnlockedEmployees);
    const streakRows = createRewardData(data?.rewards?.streakBadgeUnlockedEmployees);
    return { guideRows, storyRows, streakRows };
  }
  if (tabId === 4) {
    return data?.leaderboard?.employees?.map((d) =>
      createLeaderBoardData(d.employeeName, d.departmentRoleTitle, d.rank, d.totalStars, d.primaryContactEmail),
    );
  }
  return [];
};

export default function Insights({ insightData, tabId, openConfirmationPop }) {
  const rows = MakeRows(insightData, tabId) || [];

  const getColumnsForTab = () => {
    if (tabId === 0) {
      return columns.filter(
        (column) =>
          column.id === 'employeeName' ||
          column.id === 'departmentRoleTitle' ||
          column.id === 'lastSeen' ||
          column.id === 'employeeDevices',
      );
    }
    if (tabId === 1) {
      return columns.filter(
        (column) =>
          column.id === 'employeeName' ||
          column.id === 'departmentRoleTitle' ||
          column.id === 'learningDays' ||
          column.id === 'luCompleted',
      );
    }
    if (tabId === 2) {
      return columns.filter(
        (column) =>
          column.id === 'employeeName' ||
          column.id === 'departmentRoleTitle' ||
          column.id === 'employeeDevices' ||
          column.id === 'notificationStatus',
      );
    }
    if (tabId === 4) {
      return columns.filter(
        (column) =>
          column.id === 'employeeName' ||
          column.id === 'departmentRoleTitle' ||
          column.id === 'rank' ||
          column.id === 'totalStars',
      );
    }
    return [];
  };

  const visibleColumns = getColumnsForTab();

  function renderBadgeSection(rowsData) {
    return (
      <TableContainer sx={{ background: 'white' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: '600' }}>Employee Name</TableCell>
              <TableCell style={{ fontWeight: '600' }}>Role</TableCell>
              <TableCell style={{ fontWeight: '600' }}>Badge Threshold</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsData?.map((row, index) => (
              <TableRow key={`${row?.employeeName?.name?.toLowerCase()}-row-${index}`}>
                <TableCell style={{ width: '300px' }}>
                  <Typography variant="p" style={{ color: '#622FEE' }}>
                    {row.employeeName.name}
                    <Typography style={{ fontSize: '12px', color: 'gray' }}>{row.employeeName.email}</Typography>
                  </Typography>
                </TableCell>
                <TableCell style={{ width: '300px' }}>{row.departmentRoleTitle}</TableCell>
                <TableCell style={{ width: '200px' }}>{row.breakpoint}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  const BadgeSection = ({ title, data, rows }) => {
    return (
      <div>
        <Typography variant="body1" style={{ margin: '25px 0px 10px' }}>
          {title}
        </Typography>

        {data.length > 0 ? (
          renderBadgeSection(rows)
        ) : (
          <ZeroState
            Icon={NoUser}
            text="No users for selected time period"
            style={{ paddingBottom: '30px' }}
            cardWidth="31vw"
          />
        )}
      </div>
    );
  };

  return (
    <Grid sx={{ width: '100%', overflow: 'hidden', background: '#f3f5f6' }}>
      {tabId !== 3 ? (
        <TableContainer sx={{ maxHeight: '55vh', background: 'white' }}>
          {rows.length > 0 ? (
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {visibleColumns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth, fontWeight: '600' }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                  {tabId === 0 && (
                    <TableCell key="action" style={{ minWidth: 70, fontWeight: '600', cursor: 'pointer' }}>
                      Action
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <TableRow key={row.employeeName.name} hover role="checkbox" tabIndex={-1}>
                    {visibleColumns.map((column) => {
                      const value =
                        column.id === 'employeeDevices' ? (
                          <Grid>
                            {row[column.id]?.version ? (
                              <Typography variant="p" style={{ color: row[column.id]?.color }}>
                                {row[column.id]?.version}
                                <Typography style={{ fontSize: '12px', color: 'gray' }}>
                                  {row[column.id]?.appType}
                                </Typography>
                              </Typography>
                            ) : (
                              'NA'
                            )}
                          </Grid>
                        ) : column.id === 'employeeName' ? (
                          <Grid>
                            <Typography color="primary">{row[column.id].name}</Typography>
                            <Typography style={{ fontSize: '12px', color: 'gray' }}>{row[column.id].email}</Typography>
                          </Grid>
                        ) : column.id === 'notificationStatus' ? (
                          <Typography style={{ color: row[column.id]?.color }}>{row[column.id]?.text}</Typography>
                        ) : (
                          row[column.id]
                        );

                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === 'number' ? column.format(value) : value}
                        </TableCell>
                      );
                    })}
                    {tabId === 0 && (
                      <TableCell key={`action-${index}`} align="center">
                        {row.action && (
                          <Typography
                            onClick={() => openConfirmationPop(row)}
                            color="primary"
                            style={{
                              borderBottom: '1px solid #622FEE',
                              width: 'fit-content',
                              fontSize: '14px',
                              cursor: 'pointer',
                            }}
                          >
                            Disable
                          </Typography>
                        )}
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <ZeroState
              Icon={NoUser}
              text="No users for selected time period"
              style={{ width: '100%', height: '400px', padding: '30px 0px' }}
              cardWidth="31vw"
            />
          )}
        </TableContainer>
      ) : (
        <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
          <BadgeSection
            title="Highest Streak Badge Unlocked"
            data={insightData?.rewards?.streakBadgeUnlockedEmployees || []}
            rows={rows.streakRows}
          />

          <BadgeSection
            title="Highest Guide Badge Unlocked"
            data={insightData?.rewards?.guideBadgeUnlockedEmployees || []}
            rows={rows.guideRows}
          />

          <BadgeSection
            title="Highest Story Badge Unlocked"
            data={insightData?.rewards?.storyBadgeUnlockedEmployees || []}
            rows={rows.storyRows}
          />
        </div>
      )}
    </Grid>
  );
}
